<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="reloadTables",
    indeterminate,
    color="white",
    absolute,
    top
  )
  v-row(v-if="$showEntity('Dashboard', 'index') && hasDashboards")
    dashboard-pages(v-bind="{ dashboards, charts }")
  template(v-if="!reloadTables")
    v-row(v-if="$showEntity('OrderLine', 'PendingTasks')")
      v-col(cols="12")
        v-card.pa-4
          PendingTasks(
            :customWhere="['x => x.responsable != null']",
            customTitle="PendingTasks.pendingTasksAssigned"
          )
    v-row(v-if="$showEntity('OrderLine', 'PendingTasks')")
      v-col(cols="12")
        v-card.pa-4
          PendingTasks(
            :customWhere="['x => x.responsable == null']",
            customTitle="PendingTasks.pendingTasksUnassigned"
          )
    v-row(v-if="$showEntity('OrderLine', 'vendorsPortalCONF')")
      v-col(cols="12")
        v-card.pa-4
          ConfirmationTable
    v-row(v-if="$showEntity('OrderLine', 'vendorsPortalASN')")
      v-col(cols="12")
        v-card.pa-4
          AsnTable
    v-row(v-if="$showEntity('Shipment', 'PortalDashboard')")
      v-col(cols="12")
        v-card.pa-4
          ShipmentManagement
    v-row(v-if="$showEntity('OrderLine', 'tieManagement')")
      v-col(cols="12")
        v-card.pa-4
          TieManagement
</template>

<script>
import axios from "axios";
import ConfirmationTable from "@/components/Workstation/ConfirmationTable.vue";
import AsnTable from "@/components/Workstation/AsnTable.vue";
import PendingTasks from "@/components/Workstation/PendingTasks.vue";
import ShipmentManagement from "@/components/Workstation/ShipmentManagement.vue";
import TieManagement from "@/components/Workstation/TieManagement.vue";
import DashboardPages from "@/components/Workstation/DashboardPages.vue";

export default {
  data: function() {
    return {
      dashboards: [],
      reloadTables: false,
      charts: []
    };
  },

  /*
   * An object where keys are expressions to watch and values
   * are the corresponding callbacks. The value can also be
   * a string of a method name, or an Object that contains
   * additional options. The Vue instance will call $watch()
   * for each entry in the object at instantiation.
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/?#watch}
   * @member {Object<mixed>}
   * @memberOf Foo
   */
  watch: {
    $route(val) {
      this.reloadHome();
    },
  },
  components: {
    ConfirmationTable,
    AsnTable,
    PendingTasks,
    ShipmentManagement,
    TieManagement,
    DashboardPages,
  },
  /**
   * Methods to be mixed into the Vue instance.
   * You can access these methods directly via "this"
   * there are bound to the Vue instance.
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/#methods}
   * @member {Object<function>}
   * @memberOf Foo
   */
  methods: {
    async loadDashboards() {
      try {
        this.dashboards = (await axios.get("dashboards")).data.data;
      } catch (error) {
        console.error(error);
      }
    },
    async loadCharts() {
      try {
        this.charts = (await axios.get("charts", {
          params: {
            load: ['DataSets', 'DataSets.Criterias', 'Dimensions']
          }
        })).data.data;
      } catch (error) {
        console.error(error);
      }
    },
    async reloadHome() {
      this.reloadTables = true;
      await this.loadDashboards();
      this.reloadTables = false;
    }
  },
  computed: {
    hasDashboards() {
      return this.dashboards && this.dashboards.length > 0;
    },
  },
  async created() {
    await this.loadCharts();
    await this.loadDashboards();
  }
};
</script>
